import { IonButton, IonCheckbox, IonIcon, IonInput, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { FieldError, NormalText, Sectiontitle, SmallText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import CuratedMenusLink from '../../components/curatedMenusLink';
import NoData from '../../components/noData';
import Loading from '../../components/spinner';
import api from '../../lib/api';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import { withTranslation } from '../../lib/translate';
import { checkForDeliveryOption, createMomentFromTime, deepCopy, forwardTo, getDistanceUnit, isArray, isDefined, isObject, isTimeAvaibleInMenu, isWebConfig, parseAllergenData } from '../../lib/utils';
import { setDeliveryOption } from '../../store/actions';
import { loading, setCommonModal, setCommonProp, setMyLocation, showToast } from '../../store/common/actions';
import { SET_RESTAURANT_PROP } from '../../store/constants';
import { getIkentooMenu, getIkentooMenusForLocation, getRestaurants } from '../../store/restaurants/actions';
import { filterMenu } from '../../store/restaurants/sagas';
import { Geolocation } from '@capacitor/geolocation';
import 'moment-timezone';
import './index.css';
import 'moment-timezone';
import { isStoreOpened } from '../clickAndCollect';
import { search } from 'ionicons/icons';
import Modal from '../../components/modal';
import { ReactComponent as LocationDisabledIcon } from '../../assets/images/location-disabled.svg';

const { shouldAddPrepTime } = Basket;

const toWhichSegmentTimeBelongs = (time, segments = []) => {
	let timeIsInSegment = -1;
	segments.forEach((segment, index) => {
		const { start, end } = segment;
		const targetTime = createMomentFromTime(time);
		const segmentStart = createMomentFromTime(start);
		const segmentEnd = createMomentFromTime(end);
		if (targetTime.isSameOrAfter(segmentStart) && targetTime.isSameOrBefore(segmentEnd)) {
			timeIsInSegment = index;
		}
	});
	return timeIsInSegment;
};

const isTimeInSegment = (time, segments = []) => {
	return toWhichSegmentTimeBelongs(time, segments) !== -1;
};

const getMenusForSelectedTime = (menusForLocation = [], pick_up_at_counter_json_time_selector = []) => {
	if (isObject(menusForLocation) && !isArray(menusForLocation)) {
		menusForLocation = [menusForLocation];
	}
	const pickTime = moment().tz(getConfig().timezone).format('HH:mm');
	return menusForLocation.filter((menu) => {
		const ikentooMenuId = menu.ikentooMenuId;
		if (pick_up_at_counter_json_time_selector.length > 0 && pick_up_at_counter_json_time_selector[0].menuId && pickTime && ikentooMenuId) {
			const target_menus = pick_up_at_counter_json_time_selector.filter((i) => i.menuId.toString() === ikentooMenuId.toString());
			for (let i = 0; i < target_menus.length; i++) {
				if (
					target_menus[i] &&
					isTimeInSegment(
						pickTime,
						target_menus[i].availability.filter((i) => i.d === 'w' + moment().tz(getConfig().timezone).day()),
					)
				) {
					return true;
				}
			}
		} else {
			return false;
		}
		return false;
	});
};

class PickUpAtCounter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRestaurant: props.location.state && props.location.state.selectedRestaurant ? props.location.state.selectedRestaurant.restaurant_id : null,
			pickTime: null,
			error: '',
			modalOpen: false,
			isSelectedResButtonActive: true,
			continueButtonClicked: false,
			isLocationAllowed: false,
			renderAgain: false,
			showOnlyPickUpText: false,
			resturantIsDisabled: false,
			filterValue: ''
		};
	}

	componentDidMount() {
		if (Basket.getDeliveryOption()?.id === 'gift-vouchers') {
			Basket.reset();
		}
		if (!this.props.auth.loggedIn && !this.props.location?.state?.saveOrderData && getConfig().flags.showGuestUserModalBeforeOrder) {
			this.props.dispatch(setCommonProp('guestUserActionsModalOpen', true));
		}
		const { restaurants } = this.props;
		this.props.dispatch(loading(true));
		Basket.setOrderType('pick-up-at-counter');
		if (this.state.selectedRestaurant) {
			const selectedRestaurant = restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant);
			const orderType = getConfig().delivery.filter((el) => el.id === 'pick_up_at_counter');
			const orderTypeDisabled = orderType[0]?.isRemoved || orderType[0]?.isDisabled;
			if (selectedRestaurant.can_pick_up_at_counter && selectedRestaurant.is_published && !orderTypeDisabled) {
				Basket.setRestaurant(restaurants.find((restaurant) => restaurant.id === this.state.selectedRestaurant));
				Basket.setServicePercentage(0);
				// Basket.setProcessingFee();
			} else {
				forwardTo('/history', { tab: 'order' });
				this.props.dispatch(showToast(this.props.__('This restaurant is currently not accepting orders'), 'warning'));
				Basket.reset();
			}
		}
		let option = (getConfig().delivery || []).find((d) => d.id === Basket.order_type);
		Basket.setDeliveryOption(option);
		checkForDeliveryOption(Basket.getDeliveryOption(), '/pick-up-at-counter').then((deliveryOption) => {
			if (deliveryOption) {
				this.haveOnePublishedResturant();
				this.props.dispatch(setDeliveryOption(deliveryOption));
			}
			if (Basket.getMenu()) {
				this.setState({ selectedIkentooMenu: Basket.getMenu() });
			}
			this.props.dispatch(loading(false));
		});
		this.position();
	}
	selectRestaurant = (selectedRestaurantId) => {
		const { restaurants, profile } = this.props;
		const restaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurantId);
		let additionalSettings = restaurant && restaurant.additional_delivery_settings ? restaurant.additional_delivery_settings : {};
		additionalSettings = additionalSettings['pick_up_at_counter'];
		const hasPickUpText = additionalSettings?.pickUpText && additionalSettings?.pickUpText !== '';

		if (this.props.location?.state?.saveOrderData && Basket.has_multi_basket) {
			const restaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurantId);
			this.setState({ pickTime: 'asap', selectedRestaurant: selectedRestaurantId, showOnlyPickUpText: hasPickUpText, showChooseMenu: !hasPickUpText }, () => {
				Basket.setRestaurant(restaurant);
				Basket.setCuratedMenu(false);
				this.chooseMenusForLocation();
			});
		} else {
			this.setState({ selectedRestaurant: selectedRestaurantId, pickTime: 'asap', showOnlyPickUpText: hasPickUpText, showChooseMenu: !hasPickUpText }, async () => {
				Basket.reset(profile.cardToken);
				Basket.setRestaurant(restaurant);
				if (!this.props.location?.state?.saveOrderData) {
					if (getConfig().general.hasServiceCharge && getConfig().general.service_charge_modules?.includes('pick-up-at-counter')) {
						if (getConfig().flags.applyAutomaticServiceCharge) {
							if (Basket.getRestaurantServiceCharge()) {
								const service_charge_original = Basket.getRestaurantServiceCharge();
								Basket.setServicePercentage(Number((service_charge_original[1] * 100).toFixed(2)));
							} else {
								const defaultServiceCharge =
									typeof getConfig().general.defaultServiceCharge == 'string' ? JSON.stringify(getConfig().general.defaultServiceCharge) : getConfig().general.defaultServiceCharge;
								if (defaultServiceCharge) {
									Basket.setServicePercentage(Number((defaultServiceCharge[1] * 100).toFixed(2)));
								}
							}
						} else {
							Basket.setServicePercentage(0);
						}
					} else {
						Basket.setServicePercentage(0);
					}
				}
				Basket.setCollectionTime(null);
				Basket.setDeliveryOption(this.props.deliveryOption);
				Basket.setOrderType('pick-up-at-counter');
				this.props.dispatch(loading(true));
				let now = moment();
				if (restaurant && isDefined(restaurant.order_slot_lead_time) && shouldAddPrepTime()) {
					now.add(restaurant.order_slot_lead_time, 'minutes');
				}
				Basket.setASAP(true);
				Basket.setCollectionTime(now);
				await this.chooseMenusForLocation();
				this.props.dispatch(loading(false));
			});
		}
	};

	shouldComponentUpdate(nextProps, nextState) {
		if (
			nextState.pickTime !== this.state.pickTime ||
			nextProps.restaurants !== this.props.restaurants ||
			nextState.selectedRestaurant !== this.state.selectedRestaurant ||
			nextProps.isChooseMenuModalOpen !== this.props.isChooseMenuModalOpen ||
			nextState.continueButtonClicked !== this.state.continueButtonClicked ||
			nextState.isLocationAllowed !== this.state.isLocationAllowed ||
			nextState.renderAgain !== this.state.renderAgain ||
			nextState.filterValue !== this.state.filterValue

		) {
			return true;
		} else {
			return false;
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.isLocationAllowed !== prevState.isLocationAllowed) {
			this.props.dispatch(getRestaurants());
		}
		checkForDeliveryOption(Basket.getDeliveryOption(), '/pick-up-at-counter').then(() => {
			if (this.props.ikentooMenusForLocation.length !== prevProps.ikentooMenusForLocation.length) {
				if (this.props.ikentooMenusForLocation[0]) {
					this.setState({
						selectedIkentooMenu: this.props.ikentooMenusForLocation[0].ikentooMenuId,
					});
				}
			}
		});
	}

	selectStore = (store) => {
		this.setState({ selectedRestaurant: store.id, renderAgain: !this.state.renderAgain });
	};

	continueOnMenu = (selectedMenu = null) => {
		const { restaurants, dispatch } = this.props;
		const { selectedIkentooMenu, selectedRestaurant } = this.state;
		const menu = selectedMenu || selectedIkentooMenu;
		if (selectedRestaurant && menu) {
			const choosenRestaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurant);
			const businessLocationId = choosenRestaurant.business_location_id;
			dispatch(getIkentooMenu(menu, businessLocationId, true, 'pick_up_at_counter'));
		} else {
			this.setState({ error: 'Please select location menu' });
		}
	};

	getMenuForReorder = (menus, reorderItems) => {
		let menuForReorder = [];
		for (let i = 0; i < menus.length; i++) {
			let foundItems = 0;
			const categoryItems = menus[i].menuEntry || menus[i].menuEntryGroups || null;
			let items = Basket.flattenMenuItems(deepCopy(categoryItems));
			menus[i].flattenMenuItems = items;
			if (items.length > 0) {
				for (let j = 0; j < reorderItems.length; j++) {
					let foundItem = items.find((i) => i.sku === reorderItems[j].item.sku);
					if (foundItem) {
						foundItems = foundItems + 1;
					}
				}
			}
			menus[i].foundItems = foundItems;
			menuForReorder.push(menus[i]);
		}
		menuForReorder.sort((a, b) => b.foundItems - a.foundItems);
		if (menuForReorder[0] && menuForReorder[0].foundItems > 0) {
			return filterMenu(menuForReorder[0]);
		} else {
			return false;
		}
	};

	chooseMenusForLocation = async () => {
		const { restaurants, dispatch } = this.props;
		const { selectedRestaurant, pickTime } = this.state;
		this.setState({ continueButtonClicked: true }, async () => {
			if (selectedRestaurant && pickTime) {
				const choosenRestaurant = restaurants.find((restaurant) => restaurant.id === selectedRestaurant);
				const businessLocationId = choosenRestaurant.business_location_id;
				let currentDT = moment().tz(getConfig().timezone);
				let h = parseInt(pickTime.split(':')[0]);
				let m = parseInt(pickTime.split(':')[1]);
				const formattedDT = moment(currentDT).hours(h).minutes(m);
				Basket.setCutoffTime(currentDT.unix());
				Basket.setCollectionTime(formattedDT);
				if (this.props.location.state && this.props.location.state.selectedRestaurant) {
					this.props.dispatch(loading(true))

					let ikentooMenusForLocation = await api.getIkentooMenusForLocation(businessLocationId);
					ikentooMenusForLocation = getMenusForSelectedTime(ikentooMenusForLocation, choosenRestaurant.pick_up_at_counter_json_time_selector);
					if (ikentooMenusForLocation && isObject(ikentooMenusForLocation[0])) {
						let ikentooMenus = [];
						try {
							for (let i = 0; i < ikentooMenusForLocation.length; i++) {
								ikentooMenus.push(await api.getIkenooMenu(ikentooMenusForLocation[i].ikentooMenuId, businessLocationId, 'pick_up_at_counter'));
							}
						} catch (error) {
							this.setState({ error: 'Get restaurant menu error.' });
							this.setState({ continueButtonClicked: false });
							this.props.dispatch(loading(false))

						}
						const reorderItems = this.props.location.state.selectedRestaurant.items;
						const menu = this.getMenuForReorder(ikentooMenus, reorderItems);
						if (menu) {
							dispatch({
								type: SET_RESTAURANT_PROP,
								key: 'ikentooMenu',
								value: menu,
							});
							if (menu.flattenMenuItems.length > 0) {
								let validationStatus = {
									notBasketEmpty: false,
									validationError: false,
								};
								reorderItems.map((newBasketItem) => {
									let foundItem = menu.flattenMenuItems.find((i) => i.sku === newBasketItem.item.sku);
									if (foundItem && Basket.isProductEnabled(foundItem)) {
										if (newBasketItem?.selectedChoices?.length > 0) {
											newBasketItem.selectedChoices = Basket.filterReorderChoices(newBasketItem.selectedChoices, foundItem);
										}
										newBasketItem.item = foundItem;
										Basket.addToBasket(newBasketItem);
										let item = newBasketItem.item;
										let allergens = this.props.allergens;
										let profile = this.props.profile;
										let newArr = parseAllergenData(profile, item, allergens);
										let allergensCodes = newBasketItem.item?.itemRichData?.allergenCodes.length > 0 ? newBasketItem.item.itemRichData.allergenCodes : [];
										if (allergensCodes.length > 0) {
											let allergensData = [{ allergens: newArr }, { sku: newBasketItem.item.sku }];
											Basket.setAllergen(allergensData);
										}
										validationStatus.notBasketEmpty = true;
									} else {
										validationStatus.validationError = true;
									}
								});
								if (validationStatus.notBasketEmpty) {
									if (validationStatus.validationError) {
										dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
										this.setState({ continueButtonClicked: false });
									}
									forwardTo('/order-summary', {
										skipBackToThePreviousPage: false,
										stopLoading: true
									});
								} else {
									dispatch(showToast('Some items were not added to your basket as they are currently unavailable', 'warning'));
									this.setState({ continueButtonClicked: false });
									this.props.dispatch(loading(false))

								}
							} else {
								dispatch(showToast('Menu not found', 'warning'));
								this.setState({ continueButtonClicked: false });
								this.props.dispatch(loading(false))

							}
						} else {
							dispatch(showToast('Menu not found', 'warning'));
							this.setState({ continueButtonClicked: false });
							this.props.dispatch(loading(false))

						}
					} else {
						dispatch(showToast('Menu not found', 'warning'));
						this.setState({ continueButtonClicked: false });
						this.props.dispatch(loading(false))

					}
				} else {
					dispatch(
						getIkentooMenusForLocation(
							businessLocationId,
							{
								pickTime,
								json_time_selector: choosenRestaurant ? choosenRestaurant.pick_up_at_counter_json_time_selector : [],
							},
							false,
						),
					);
					this.setState({ continueButtonClicked: false });
				}
			} else if (!selectedRestaurant) {
				this.setState({ error: 'Please select location' });
			} else {
				this.setState({ error: 'Please select pickup time' });
			}
		});
	};

	changeIkentooMenus = (event) =>
		this.setState({ selectedIkentooMenu: event.detail.value, error: '' }, () => {
			Basket.setMenu(event.detail.value);
		});

	position = async () => {
		const myLocation = {
			latitude: null,
			longitude: null
		};
		try {
			const coordinates = await Geolocation.getCurrentPosition({
				enableHighAccuracy: true,
			});
			myLocation.latitude = coordinates.coords.latitude;
			myLocation.longitude = coordinates.coords.longitude;
			this.setState({ isLocationAllowed: true });
		} catch (error) {
			console.log('Error getting location: ' + error.message);
			this.setState({ isLocationAllowed: false });
		}
		this.props.dispatch(setMyLocation(myLocation));
	};

	formatDataForSelect = (stores) => {
		let formatedStores = [];
		stores.forEach((store) => {
			const currentDT = moment().tz(getConfig().timezone);
			let minDT = currentDT;
			if (store && isDefined(store.order_slot_lead_time) && shouldAddPrepTime()) {
				minDT.add(store.order_slot_lead_time, 'minutes');
			}
			const storeOpened = isStoreOpened(store);
			const slotsAvailable = isTimeAvaibleInMenu(store.pick_up_at_counter_json_time_selector, currentDT);
			store.opened = slotsAvailable;

			if (storeOpened && slotsAvailable) {
				store.openLabel = 'OPEN';
			} else if (storeOpened && !slotsAvailable) {
				store.openLabel = 'UNAVAILABLE';
			} else if (!storeOpened && slotsAvailable) {
				store.openLabel = 'PREORDER';
			} else if (!storeOpened && !slotsAvailable) {
				store.openLabel = 'CLOSED';
			}
			if (store.is_published && store.can_pick_up_at_counter) {
				formatedStores.push(store);
			}
		});
		if (this.state.isLocationAllowed) {
			formatedStores.sort(function (a, b) {
				return a.distance < b.distance ? -1 : a.distance > b.distance ? 1 : 0;
			});
		} else {
			formatedStores.sort(function (a, b) {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
		}
		return formatedStores;
	};

	haveOnePublishedResturant = () => {
		const { __ } = this.props;
		const restaurantArr = this.props.restaurants.filter((restaurant) => restaurant.is_published === true && restaurant.can_pick_up_at_counter === true);
		if (restaurantArr.length === 1 && this.state.selectedRestaurant === null && restaurantArr[0].opened) {
			const restaurant = restaurantArr[0];
			const additional_delivery_settings = restaurant.additional_delivery_settings || {};
			const additionalSettings = additional_delivery_settings[this.props.deliveryOption?.id] || {};
			if (!isStoreOpened(restaurant)) {
				this.setState({ resturantIsDisabled: true });
			} else {
				this.selectRestaurant(restaurant.id);
				this.setState({ isSelectedResButtonActive: false });
			}
		}
	};

	getKitchenStatusColor(status) {
		let color = '';
		switch (status) {
			case 0:
				color = 'success';
				break;
			case 1:
				color = 'warning';
				break;
			case 2:
				color = 'danger';
		}
		return color;
	}
	isRestaurantOpenForReorder = (stores, restaurant) => {
		if (this.props.location?.state?.reorder) {
			const selectedRestaurant = stores.find(el => el.id == restaurant)
			if (selectedRestaurant) {
				return !selectedRestaurant.opened
			} else {
				return true
			}
		} else {
			return false
		}
	}
	render() {
		const { __, restaurants, ikentooMenusForLocation, isChooseMenuModalOpen, deliveryOption } = this.props;
		const { error, selectedRestaurant, pickTime, selectedIkentooMenu, showOnlyPickUpText, resturantIsDisabled, filterValue } = this.state;
		const animationMenuClass = isChooseMenuModalOpen ? 'show-up' : '';
		const store = restaurants.find((restaurant) => restaurant.id === selectedRestaurant) || null;
		const stores = restaurants || [];
		const menus = getMenusForSelectedTime(ikentooMenusForLocation, store && store.pick_up_at_counter_json_time_selector ? store.pick_up_at_counter_json_time_selector : []);
		let formatedStores = this.formatDataForSelect(stores);
		let additionalSettings = store && store.additional_delivery_settings ? store.additional_delivery_settings : {};
		additionalSettings = additionalSettings['pick_up_at_counter'];
		const pickUpText = additionalSettings?.pickUpText;
		if (Basket.has_multi_basket && getConfig().flags.geolocationDisabled) {
			const stores = deepCopy(formatedStores);
			let openedRestaurants = stores.filter((store) => store.opened);
			let closedRestaurants = stores.filter((store) => !store.opened);
			openedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			openedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			closedRestaurants.sort((a, b) => {
				return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
			});
			closedRestaurants.sort((a, b) => a.sort_order - b.sort_order);
			formatedStores = [...openedRestaurants, ...closedRestaurants];
		}
		const filterReastaurants = formatedStores.filter(r =>
			r.name.toLowerCase().includes(filterValue.toLowerCase())
		);

		return (
			<Loading transparent>
				<Layout showLoginIcon={getConfig().flags.hasGuestCheckout && Basket.itemsCount() == 0} showHamburger title={__('Pick up at Counter')} headerWithTitle={true} color="transparent" scrollY={false}>
					<div className={`${getConfig().general.tiledRestaurantView?'scrollable-y':'flex-row-wrapper'} absolute-content box-with-shadow`}>
						{filterReastaurants?.length > 0 || filterValue !== '' ? <>
							<Title className="web-only page-title-centered">{__('Pick up at Counter')}</Title>
							{showOnlyPickUpText ? null :
								<>
									<StrongText className='block text-to-update page-title-centered'>{__('Select a restaurant to collect your order')}</StrongText>
									<Spacer size={2} />
								</>
							}
							{!showOnlyPickUpText || ikentooMenusForLocation.length === 0 ? (
								<>
									{!this.props.myLocation.latitude && getConfig().flags.hasDisabledLocationRestaurantsFilter &&
										<div className='restaurants-filter-wrapper'>
											<div className='box-content restaurants-filter-box'>
												<LocationDisabledIcon />

												<div>
													<SmallText className='bold'>{__('Location services unavailable')}</SmallText>
													<SmallText>{__('Please select your nearest store manually.')}</SmallText>

												</div>
											</div>
											<Spacer size={2} />
											<IonItem className='input-field-wrapper' lines='none'>
												<IonInput
													onIonInput={(e) => this.setState({ filterValue: e.target.value })}
													type="text"
													pattern="text"
													inputmode="text"
													placeholder={__('Search by store name or location')}
												/>
												<IonIcon icon={search} slot='start' />

											</IonItem>
											<Spacer size={2} />

										</div>
									}
									<CuratedMenusLink saveOrderData={this.props.location?.state?.saveOrderData} />
									<div className="order-locations-wrapper">
										<IonList className={` ${getConfig().general.tiledRestaurantView ? 'tiled-box-wrapper' : 'box-wrapper'}`}>
											{filterReastaurants.length > 0 ? <>
											{filterReastaurants.map((store, i) => (
												<React.Fragment key={`store_${i}`}>
													{getConfig().general.tiledRestaurantView ? (
														<IonItem
															disabled={!store.can_pick_up_at_counter || resturantIsDisabled || !store.opened}
															className="pointer restaurant-wrapper box-wrapper"
															onClick={() => this.selectRestaurant(store.id)}
															lines="none"
															key={i}
														>
															<div style={{ width: '100%' }}>
																<img src={store.image} />
																<IonLabel>
																	<StrongText className='text-to-update block'>{__(store.name)}</StrongText>
																	<div className="restaurant-data" dangerouslySetInnerHTML={{ __html: store.info_html }}></div>
																</IonLabel>
																{!getConfig().flags.removeKitchenStatus &&
																	<SmallText className="restaurant-status">{store.counter_kitchen_status.text}</SmallText>
																}
															</div>
														</IonItem>
													) : (
														<IonItem
															disabled={!store.can_pick_up_at_counter || resturantIsDisabled || !store.opened}
															onClick={() => this.selectStore(store)}
															lines="none"
															key={i}
														>
															<IonLabel className="break-space">
																<StrongText className='text-to-update block'>{__(store.name)}</StrongText>
																<SmallText className="block">{__(store.address)}</SmallText>
																{store.distance && !Basket.has_multi_basket && (
																	<SmallText className=" block bold-description click-collect-small-description">
																		{`${parseFloat(store.distance.toFixed(2)) == 1 ? store.distance.toFixed(0) : store.distance.toFixed(2)} ${__(getDistanceUnit(parseFloat(store.distance.toFixed(2)) == 1))}`}
																	</SmallText>
																)}
																{!getConfig().flags.removeKitchenStatus &&
																	<>
																		{store.counter_kitchen_status && (
																			<SmallText className={`kitchen-status-wrapper ${this.getKitchenStatusColor(store.counter_kitchen_status.status)}-color block`}>
																				{store.counter_kitchen_status.text}
																			</SmallText>
																		)}
																	</>
																}

																<SmallText className="restaurant-opening-time">{__(store.openLabel)}</SmallText>
															</IonLabel>
															<IonCheckbox className='round-checkbox' checked={selectedRestaurant && store.id === selectedRestaurant} slot="start" color="primary" />
														</IonItem>
													)}
												</React.Fragment>
											))}
											</> : <div className='centered'>
												<NormalText>{__('No locations found')}</NormalText>
											</div>}
										</IonList>
									</div>
									{getConfig().frenchDisclaimer?.disclaimerImage && (
										<>
											<Spacer size={5} />
											<div className="disclaimer-wrapper">
												<img src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
											</div>
										</>
									)}
									{!getConfig().general.tiledRestaurantView && (
										<>
											<Spacer size={5} />
											<IonButton
												{...(getConfig()?.customButtons?.order?.counter && { style: { '--ion-color-primary': getConfig()?.customButtons?.order?.counter } })}
												disabled={!selectedRestaurant || formatedStores.length === 0 || this.isRestaurantOpenForReorder(formatedStores, selectedRestaurant)}
												expand="block"
												color="primary"
												className='button-uppercase'
												onClick={() =>
													this.setState({ filterValue: '' }, () => {
														this.selectRestaurant(selectedRestaurant)
													})

												}
											>
												{__('Continue')}
											</IonButton>
										</>
									)}
								</>
							) : (
								<>
									<>
										<div dangerouslySetInnerHTML={{ __html: pickUpText }} />
									</>
									<Spacer size={2} />
									<IonButton
										disabled={!pickTime}
										expand="block"
										color="primary"
										className={`${this.state.continueButtonClicked ? 'unclicked' : ''} button-uppercase`}
										onClick={() => (menus && menus.length === 1 ? this.continueOnMenu(menus[0].ikentooMenuId) : this.chooseMenusForLocation())}
									>
										{__('Continue')}
									</IonButton>
								</>
							)}
						</> : <div className='centered'>
							<StrongText className='text-to-update page-title-centered'>{__(`Sorry, pick up at counter is not available at this time...`)}</StrongText>

						</div>}
					</div>
					{menus.length && menus > 1 ? (
						<>
							<Modal
								isOpen={isChooseMenuModalOpen}
								onDidDismiss={() => this.props.dispatch(setCommonModal('isChooseMenuModalOpen', false))}

							>
								<Title className='modal-title'>{__('Choose menu')}</Title>
								<Spacer size={5} />
								<IonList lines="none" className="box-wrapper menus-wrapper">
									<IonRadioGroup onIonChange={this.changeIkentooMenus} value={selectedIkentooMenu}>
										{!menus.length ? (
											<NoData />
										) : (
											menus.map((menu) => {
												const { ikentooMenuId, menuName } = menu;
												return (
													<IonItem key={ikentooMenuId} lines="none">
														<div tabIndex="-1"></div>
														<StrongText className="ion-text-wrap">
															{menuName}
														</StrongText>
														<IonRadio color='primary' slot="start" value={ikentooMenuId} />
													</IonItem>
												);
											})
										)}
									</IonRadioGroup>
								</IonList>
								<Spacer size={5} />
								<IonButton
									disabled={pickTime && menus.length > 0 ? false : true}
									expand="block"
									color="primary"
									className="customized-button button-uppercase"
									onClick={() => this.continueOnMenu()}
								>
									{__('Continue')}
								</IonButton>
							</Modal>

						</>
					) : null}
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { isChooseMenuModalOpen, orderProductionMins, myLocation } = state.common;
	const { restaurants, ikentooMenu, ikentooMenusForLocation } = state.restaurants;
	const { deliveryOption } = state.orders;
	const { auth, profile } = state.profile
	return {
		auth,
		isChooseMenuModalOpen: isChooseMenuModalOpen,
		restaurants: restaurants || [],
		ikentooMenu: ikentooMenu || {},
		ikentooMenusForLocation: ikentooMenusForLocation || [],
		profile,
		deliveryOption,
		orderProductionMins: orderProductionMins,
		auth,
		myLocation
	};
};

export default connect(stateToProps)(withTranslation(PickUpAtCounter));
